import { React, useState, useEffect, useContext, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import editImg from "../../../assets/img/icon/edit.svg";
import deleteImg from "../../../assets/img/icon/delete.svg";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import { IconEye } from '@tabler/icons-react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactSwitch from "react-switch";
import * as SwitchProps from "../../../component/utilities/ReactSwitchReactSwitchProps";
import { EditIcon, DeleteIcon, CommentIcon, ViewIcon } from '../../../component/utilities/ActionIcons';
import JoditEditor from "jodit-react";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import parse from "html-react-parser";
import viewImg from "../../../assets/img/icon/index.png";
import ReorderArticlesModal from './updateQuestionOrderModal'

function TechQuestionAnswer() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});

  const handleClearValidate = (name) => {
    if (validate.validate && validate.validate[name]) {
      setValidate({
        validate: { ...validate.validate, [name]: undefined },
      });
    }
  };
  const [disabled, setDisabled] = useState(false);
  //const [processing, setProcessing] = useState(false);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [questionId, setQuestionId] = useState(0);
  const MySwal = withReactContent(Swal);
  const [listLimit, setListLimit] = useState(50);

  const [action, setAction] = useState("");

  /** For Modalpopup */
  const [show, setShow] = useState(false);

  /* START DATATABLE */
  const [totalRecords, settotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);

  //Search
   const [searchQuestionStatus, setsearchQuestionStatus] = useState("");
  const [searchQuestionTitle, setsearchQuestionTitle] = useState("");

  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const pageNumberLimit = { perPage };

  //For Form
  const [questionTitle, setQuestionTitle] = useState("");
  const [techDescription, setDescription] = useState("");
  const [status, setStatus] = useState(false);
  const [allTechVersions, setAllTechVersions] = useState([]);
  const [techName, setTechName] = useState("");
  const [dbVersionValue, setDbVersionValue] = useState("");
  const [rejectShow, setRejectShow] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [viewShow, setViewShow] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [versionValue, setVersionValue] = useState("");
  const [commentShow, setCommentShow] = useState(false);
  const [commentData, setCommentData] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [searchApprovalStatus, setsearchApprovalStatus] = useState("");
const [technologyId, setTechnologyId] = useState(null);
  const [showReorder, setShowReorder] = useState(false);
 

  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      uploader: { insertImageAsBase64URI: true },
    }),
    []
  );

  const params = useParams();
  let id = params.id;

  let isToken = "";
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
    }
  }

  const [searchParam, setSearchParam] = useState({
    srchStatus: searchQuestionStatus,
  });

  useEffect(() => {
    if (authUserData[0]?.user_role !== "Admin") {
      // If not admin, you shouldn't be on this management page
      // But we'll let the fetch handle it or show an error
    }
    fetchTechnologyById(id);
    fetchTechnologyQuestions(searchParam, dataSort, activePage, perPage, id);
    getVersions();
  }, [searchParam, dataSort, activePage, listLimit]);



  async function getVersions() {
    let apiUrl = CONST.GET_TECHNOLOGY_VERSIONS + `${id}`;
    let strMethod = "get";
    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          let versionDetails = response.data.data;
          let optionsVersion = versionDetails.map((v, index) => ({
            label: v.version,
            value: String(v.id),
          }));
          setAllTechVersions(optionsVersion);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleShow(action, questionId) {
    setValidate({});
    const question_id = questionId ? questionId : 0;
    setQuestionId(question_id);
    setQuestionTitle("");
    setStatus("");
    setVersionValue("");
    setDbVersionValue("");
    setDescription("");

    if (question_id !== 0) {
      fetchQuestionById(question_id);
    }
    setAction(action);
    setShow(true);
  }

  async function questionSearch() {
    setSearchParam({
      srchStatus: searchQuestionStatus,
      srchTitle: searchQuestionTitle,
      srchApprovalStatus: searchApprovalStatus,
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  }

  const clearSearch = () => {
    setsearchQuestionStatus("");
    setsearchQuestionTitle("");
    setsearchApprovalStatus("");
    setSearchParam({
      srchStatus: "",
      srchTitle: "",
      srchApprovalStatus: "",
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  };


  const handleOnchange = (val) => {
    handleClearValidate("versionValue");
    setVersionValue(val);
  };

  const handleClose = () => {
    setValidate({});
    setShow(false);
    setQuestionId(0);
    setQuestionTitle("");
    setStatus("");
  };

  function deleteHandler(questionId, technologyId) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Question?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        if (questionId > 0) {
          setLoading(true);
          axios
            .delete(CONST.DELETE_QUESTION_DETAILS, {
              headers: {
                Authorization: `Bearer ${isToken}`,
              },
              data: {
                technology_id: technologyId,
                question_id: questionId,
              },
            })
            .then((response) => {
              if (response) {
                if (response.data.status == "error") {
                  toast.error(response.data.message);
                } else {
                  toast.success(response.data.message);
                  fetchTechnologyQuestions(
                    searchParam,
                    dataSort,
                    activePage,
                    perPage,
                    id
                  );
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Something went wrong. Please try again." + error);
            });
          setLoading(false);
        }
      }
    });
  }

  //fetch all Technology data by id
  async function fetchTechnologyById(technologyId) {
    setLoading(true);
    let apiUrl = CONST.GET_TECHNOLOGY_BY_ID + `${technologyId}`;
    let strMethod = "put";
    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;

        if (status === "success") {
          let technologyData = response.data.data ? response.data.data : [];

          setTechName(technologyData["name"]);
        }
      })
      .catch((error) => {
        alert(error);
      });
    setLoading(false);
  }

  //fetch all Question data by id
  async function fetchQuestionById(questionId) {
    setLoading(true);
    let apiUrl = CONST.GET_QUESTION_BY_ID + `${questionId}`;
    let strMethod = "put";

    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;

        if (status === "success") {
          let questionData = response.data.data ? response.data.data : [];
          let arrVersion = questionData["question_versions"]
            ? questionData["question_versions"].map(
                (v, index) => v.versionData?.id || v.version_id
              )
            : "";
          setDbVersionValue(arrVersion);
          setVersionValue(arrVersion.toString());

          setQuestionTitle(questionData["title"] ? questionData["title"] : "");
          setDescription(
            questionData["description"] ? questionData["description"] : ""
          );
          setStatus(questionData["status"] ? questionData["status"] : "");
        }
      })
      .catch((error) => {
        alert(error);
      });
    setLoading(false);
  }

  //fetch all technology details
  async function fetchTechnologyQuestions(
    paramSearch,
    paramSort,
    paramPage,
    paramLimit,
    techId
  ) {
    setLoading(true);
    await axios
      .post(
        CONST.GET_QUESTIONS_LIST,
        {
          technology_id: techId,
          limit: paramLimit,
          search_input: paramSearch,
          page_number: paramPage,
          sort: paramSort,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setData(response.data.data);
          setTotalRows(response.data.count);
          settotalRecords(response.data.count);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {});
    setLoading(false);
  }

  const fetchComments = async (questionId) => {
    setCommentLoading(true);
    setCommentShow(true);
    try {
      const response = await axios.post(CONST.GET_QUESTION_COMMENT_LIST, {
        question_id: questionId,
      }, {
        headers: { Authorization: `Bearer ${isToken}` }
      });
      if (response.data.status === "success") {
        setCommentData(response.data.data);
      } else {
        setCommentData([]);
      }
    } catch (error) {
      console.error(error);
      setCommentData([]);
    } finally {
      setCommentLoading(false);
    }
  };
  // const handleUpdateStatus = async (commentId, status) => {
  //   try {
  //     // Show a small loader or disable buttons here if you have a local processing state
  //     const response = await axios.post(
  //       CONST.UPDATE_COMMENT_STATUS,
  //       {
  //         comment_id: commentId,
  //         is_approve: status,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${isToken}` },
  //       },
  //     );
const handleUpdateStatus = async (commentId, status) => {
    try {
      // Show a small loader or disable buttons here if you have a local processing state
      const response = await axios.post(
        CONST.UPDATE_COMMENT_STATUS,
        {
          comment_id: commentId,
          is_approve: status,
        },
        {
          headers: { Authorization: `Bearer ${isToken}` },
        },
      );

    if (response.data.status === "success") {
      toast.success(
        `Comment ${status === "1" ? "Approved" : "Rejected"} successfully`,
      );

      // UPDATE LOCAL STATE TO REMOVE BUTTONS
      setCommentData((prevData) =>
        prevData.map((comment) =>
          comment.id === commentId
            ? { ...comment, is_approve: status }
            : comment,
        ),
      );
    } else {
      toast.error("Failed to update status");
    }
  } catch (error) {
    console.error("Status update error:", error);
    toast.error("An error occurred");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let arrDifference = "";

    let validator = Form.validator({
      versionValue: {
        value: versionValue,
        isRequired: true,
        label: "Question version",
      },
      questionTitle: {
        value: questionTitle,
        isRequired: true,
        label: "Question",
      },
      techDescription: {
        value: techDescription,
        isRequired: true,
        label: "Description",
      },
    });

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    }

    if (isValid) {
      setDisabled(true);
      let apiUrl = "";
      let sucessMessage = "";
      let strMethod = "";

      if (questionId == 0) {
        apiUrl = CONST.ADD_QUESTION;
        strMethod = "post";
        sucessMessage = "Question added succesfully";
      } else {
        apiUrl = CONST.UPDATE_QUESTION;
        strMethod = "post";
        sucessMessage = "Question updated succesfully";
      }

      var strUpdatedValue = versionValue.split(",");

      if (dbVersionValue !== "") {
        arrDifference = dbVersionValue.filter(
          (i) => strUpdatedValue.indexOf(i) === -1
        );
        arrDifference = arrDifference.toString();
      }
      await axios({
        method: strMethod,
        url: apiUrl,
        data: {
          technology_id: id,
          question_id: questionId,
          title: questionTitle,
          version_id: [versionValue],
          description: techDescription,
          status: status == "1" || status == "" ? "1" : "0",
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status == "error") {
              setDisabled(false);
              toast.error(response.data.message || "Something went wrong. Please try again.");
            } else {
              toast.success(sucessMessage);
              setDisabled(false);
              fetchTechnologyQuestions(
                searchParam,
                dataSort,
                activePage,
                perPage,
                id
              );
              handleClose();
              if (arrDifference.length > 0 && questionId > 0) {
                let apiUrl = CONST.DELETE_TECH_QUESTION_VERSIONS;
                let strMethod = "delete";
                axios({
                  method: strMethod,
                  url: apiUrl,
                  data: {
                    question_id: questionId,
                    version_id: [arrDifference],
                  },
                  headers: {
                    Authorization: `Bearer ${isToken}`,
                  },
                })
                  .then((response) => {
                    const status = response.data.status;
                    if (status == "success") {
                      fetchTechnologyQuestions(
                        searchParam,
                        dataSort,
                        activePage,
                        perPage,
                        id
                      );
                      //console.log(response.data.message);
                    } else {
                      //console.log(response.data.message);
                    }
                  })
                  .catch((error) => {
                    toast.error(error.response?.data?.message || "There was an error.");
                  });
              }
            }
          }
        })
        .catch((error) => {
          setDisabled(false);
          setLoading(false);
          toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
        });
    }
  };

  const handleChangeStatus = (index, status_value, question_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(
            CONST.UPDATE_QUESTION_STATUS,
            {
              question_id: question_id,
              status: status_value == "0" ? "1" : "0",
            },
            {
              headers: {
                Authorization: `Basic ${isToken}`,
              },
            },
          )
          .then((response) => {
            const status = response.data.status;
            if (status == "success") {
              toast.success(response.data.message);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            toast.error(error.response?.data?.message || "There was an error.");
          });
        setLoading(false);

        const newData = [...data];
        newData[index].status = status_value == 0 ? 1 : 0;
        setData(newData);
      }
    });
  };

  const handleApproveReject = (question_id, action, reason = "") => {
    setLoading(true);
    axios
      .post(
        CONST.APPROVE_REJECT_QUESTION,
        {
          question_id: question_id,
          action: action,
          rejection_reason: reason,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          fetchTechnologyQuestions(searchParam, dataSort, activePage, perPage, id);
          if (action === "reject") setRejectShow(false);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "Failed to update approval status.");
      });
  };

  const handleOrderChange = (question_id, version_id, new_order) => {
    if (!new_order || isNaN(new_order)) return;
    setLoading(true);
    axios
      .post(
        CONST.UPDATE_QUESTION_ORDER,
        {
          question_id: question_id,
          technology_id: id,
          version_id: version_id,
          new_order: parseFloat(new_order),
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          fetchTechnologyQuestions(searchParam, dataSort, activePage, perPage, id);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "Failed to update order.");
      });
  };

  const columns = [
    {
    width:"1%"
  },
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "5%",
    },
    {
      name: "Article Title",
      selector: (row) => row.title,
      width: "15%",
    },

    {
      name: "version",
      selector: (row) =>
        row.question_versions !== null
          ? row.question_versions.map((v, index) => v.version_id ).join(", ")
          : "",
      width: "15%",
    },
    {
      name: "Created By",
      width: "15%",
      selector: (row) =>
        row.creator
          ? `${row.creator.first_name} ${row.creator.last_name}`
          : "System / Admin",
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">
            {row.creator
              ? `${row.creator.first_name} ${row.creator.last_name}`
              : "System / Admin"}
          </span>
          {row.creator?.email && (
            <small className="text-muted">{row.creator.email}</small>
          )}
        </div>
      ),
    },
    {
      name: "Approval Status",
      width: "15%",
      cell: (row) => {
        const approvalStatus = row.approval_status || "pending";

        const formattedStatus =
          approvalStatus.charAt(0).toUpperCase() + approvalStatus.slice(1);

        return (
          <div className="d-flex justify-content-center">
            <span
              className={`db-status-badge ${
                approvalStatus === "approved"
                  ? "db-badge-success"
                  : approvalStatus === "rejected"
                  ? "db-badge-danger"
                  : "db-badge-warning"
              }`}
            >
              {formattedStatus}
            </span>
          </div>
        );
      },
    },
   
    {
      name: "Status",
      omit: authUserData[0]?.is_admin != 1,
      width: "15%",
      selector: (row, index) => (
        <ReactSwitch
          onColor={SwitchProps.onColor}
          onHandleColor={SwitchProps.onHandleColor}
          handleDiameter={SwitchProps.handleDiameter}
          uncheckedIcon={SwitchProps.uncheckedIcon}
          checkedIcon={SwitchProps.checkedIcon}
          boxShadow={SwitchProps.boxShadow}
          activeBoxShadow={SwitchProps.activeBoxShadow}
          height={SwitchProps.height}
          width={SwitchProps.width}
          className={SwitchProps.className}
          checked={row.status == 1 ? true : false}
          onChange={() => {
            handleChangeStatus(index, row.status, row.id);
          }}
        />
      ),
    },
    {
      name: "Action",
      width: "15%",
      wrap: true,
      sortable: false,
      cell: (row) => <Action row={row} />,
    },
  ];

  const Action = ({ row }) => (
    <div className="d-flex align-items-center gap-2">
      {(authUserData[0]?.is_admin == 1 ||
        row.created_by === authUserData[0]?.id) && (
        <>
          <EditIcon onClick={() => handleShow("Edit", row.id)} tooltip="Edit" />
          <DeleteIcon onClick={() => deleteHandler(row.id, row.technology_id)} tooltip="Delete" />
        </>
      )}

      <CommentIcon onClick={() => fetchComments(row.id)} tooltip="Comments" />
      <ViewIcon 
        onClick={() => {
          setViewData(row);
          setViewShow(true);
        }} 
        tooltip="View Details" 
      />
    </div>
  );

  const handleSort = async (column, sortDirection) => {
    setActivePage(1);
    setSearchParam({
      search: "no",
      name: "",
      status: "",
    });

    setDataSort({
      order: sortDirection,
      order_by: column.sortField,
    });
    /*  setLoading(false); */
  };
  /*  PAGINATION FUNCTIONS  */
  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };

  const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    //onChangeRowsPerPage, // available but not used here
    currentPage,
  }) => {
    function toPages(pages) {
      const results = [];
      for (let i = 1; i <= pages; i++) {
        results.push(i);
      }
      return results;
    }
    function getNumberOfPages(rowCount, rowsPerPage) {
      return Math.ceil(rowCount / rowsPerPage);
    }

    const handleBackButtonClick = async () => {
      if ((currentPage - 1) % pageNumberLimit === 0) {
        setMaxPageLimit(maxPageLimit - pageNumberLimit);
        setMinPageLimit(minPageLimit - pageNumberLimit);
      }
      onChangePage(currentPage - 1);
    };

    const handleNextButtonClick = async () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + pageNumberLimit);
        setMinPageLimit(minPageLimit + pageNumberLimit);
      }

      onChangePage(currentPage + 1);
    };

    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };

    let paginationText = "Page:  " + currentPage + ", Showing ";

    paginationText =
      paginationText +
      ((currentPage - 1) * perPage + 1) +
      " to " +
      perPage * currentPage;
    paginationText = paginationText + " of " + rowCount + " entries;";

    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li
            key={page}
            id={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className={`page-link ${currentPage === page ? "active" : ""}`}
              onClick={handlePageNumber}
              value={page}
            >
              {page}
            </button>
          </li>
        );
      } else {
        return null;
      }
    });
    let pageIncrementEllipses = null;
    if (pageItems.length > maxPageLimit) {
      pageIncrementEllipses = (
        <li className="page-item" onClick={handleNextButtonClick}>
          &hellip;
        </li>
      );
    }
    let pageDecremenEllipses = null;
    if (minPageLimit >= 1) {
      pageDecremenEllipses = (
        <li className="page-item" onClick={handleBackButtonClick}>
          &hellip;
        </li>
      );
    }
    return (
      <div className="card-footer d-flex justify-content-between">
        <p className="m-0 text-muted">{paginationText}</p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
              aria-disabled={previosDisabled}
              aria-label="previous page"
              pagerangedisplayed={10}
            >
              «
            </button>
          </li>
          {pageDecremenEllipses}
          {pageNumbers}
          {pageIncrementEllipses}
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
              aria-disabled={nextDisabled}
              aria-label="next page"
            >
              »
            </button>
          </li>
        </ul>
      </div>
    );
  };
  /* END DATATABLE */
  const CustomLoader = () => (
    <div style={{ padding: "24px" }}>
      <DivLoader color="primary" />
    </div>
  );
  return (
    <>
      <Loading
        loading={fullLoading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
      {authUserData[0]?.is_admin != 1 ? (
        <div className="page-body">
          <div className="container-xl d-flex flex-column justify-content-center">
            <div className="empty bg-white p-5 rounded shadow-sm">
              <div className="empty-header text-danger">403</div>
              <p className="empty-title">Access Denied</p>
              <p className="empty-subtitle text-muted">
                You do not have permission to access the Admin Article
                Management page.
              </p>
              <div className="empty-action">
                <Link
                  to={CONST.ADMIN_PRE + "account/articles"}
                  className="btn btn-primary"
                >
                  Go to Employee Library
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <HeaderSection
            title="Manage"
            heading="Articles"
            addButton={() => handleShow("Add", 0)}
            addLink="#"
            addLinkName="Add Article"
            linktype="add"
          />
          <div className="page-body">
            <div className="container-xl">
              <div className="row row-cards">
                <div className="col-12">
                  <div className="card shadow-sm">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h3 className="card-title">
                        {techName} - Article Listing{" "}
                      </h3>
                      <div className="w-50 d-flex justify-content-end">
                        <Link
                          to="#"
                          className="btn btn-outline-primary btn-sm"
                          onClick={(e) => {
                            e.preventDefault();
                            setTechnologyId(id);
                            setShowReorder(true);
                          }}
                        >
                          Order approved articles
                        </Link>

                        <Link
                          to={CONST.ADMIN_PRE + "library"}
                          className="btn btn-primary btn-sm ml-3"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-arrow-left"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <path d="M5 12l14 0"></path>
                            <path d="M5 12l6 6"></path>
                            <path d="M5 12l6 -6"></path>
                          </svg>
                          Back to technologies
                        </Link>
                      </div>
                    </div>
                    <div className="card-body border-bottom py-3">
                      <div className="row g-3 align-items-end">
                        {/* Status Filter */}
                        <div className="col-md-3">
                          <label className="form-label">Status Filter</label>
                          <select
                            className="form-select"
                            value={searchQuestionStatus}
                            onChange={(e) =>
                              setsearchQuestionStatus(e.target.value)
                            }
                          >
                            <option value="">All Statuses</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>

                        {/* Search Input */}
                        <div className="col-md-3">
                          <label className="form-label">Search by Title</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter keywords..."
                            value={searchQuestionTitle}
                            onChange={(e) =>
                              setsearchQuestionTitle(e.target.value)
                            }
                          />
                        </div>

                        {/* Approval Filter */}
                        <div className="col-md-3">
                          <label className="form-label">Approval Status</label>
                          <select
                            className="form-select"
                            value={searchApprovalStatus}
                            onChange={(e) =>
                              setsearchApprovalStatus(e.target.value)
                            }
                          >
                            <option value="">All Articles</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                          </select>
                        </div>

                        <div className="col-md-3 d-flex align-items-end">
                          <div className="d-flex gap-2 flex-nowrap">
                            <button
                              type="button"
                              className="btn btn-primary d-flex align-items-center"
                              onClick={questionSearch}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                className="me-1"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                              >
                                <circle cx="10" cy="10" r="7"></circle>
                                <line x1="21" y1="21" x2="15" y2="15"></line>
                              </svg>
                              Search
                            </button>

                            <button
                              type="button"
                              className="btn btn-outline-primary d-flex align-items-center ml-3"
                              onClick={clearSearch}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                className="me-1"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                              >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <DataTable
                        columns={columns}
                        data={data}
                        progressPending={loading}
                        progressComponent={<CustomLoader />}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangePage={handlePageChange}
                        paginationComponent={BootyPagination}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modals */}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{action} Article</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label required">
                  Technology Version(s)
                </label>
                <MultiSelect
                  value={versionValue}
                  onChange={handleOnchange}
                  options={allTechVersions}
                  className={validate.validate?.versionValue ? "is-invalid" : ""}
                />
                {validate.validate?.versionValue && (
                  <div className="invalid-feedback d-block">
                    {validate.validate.versionValue}
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label required">Article Title</label>
                <input
                  type="text"
                  className={`form-control ${validate.validate?.questionTitle ? "is-invalid" : ""}`}
                  value={questionTitle}
                  onChange={(e) => {
                    setQuestionTitle(e.target.value);
                    handleClearValidate("questionTitle");
                  }}
                />
                {validate.validate?.questionTitle && (
                  <div className="invalid-feedback">
                    {validate.validate.questionTitle}
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label required">
                  Description / Content
                </label>
                <JoditEditor
                  ref={editor}
                  config={config}
                  value={techDescription}
                  onBlur={(newContent) => {
                    setDescription(newContent);
                    if (newContent) handleClearValidate("techDescription");
                  }}
                />
                {validate.validate?.techDescription && (
                  <div className="invalid-feedback d-block">
                    {validate.validate.techDescription}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">Visibility Status</label>
                <select
                  className="form-select"
                  onChange={(e) => setStatus(e.target.value)}
                  value={status}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={disabled}>
            {disabled ? "Submitting..." : "Add Article"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={rejectShow} onHide={() => setRejectShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Rejection Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Please explain why this article was rejected..."
            onChange={(e) => setRejectComment(e.target.value)}
            value={rejectComment}
          ></textarea>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setRejectShow(false)}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() =>
              handleApproveReject(currentQuestionId, "reject", rejectComment)
            }
          >
            Confirm Rejection
          </Button>
        </Modal.Footer>
      </Modal>

      <ViewArticleModal
        show={viewShow}
        handleClose={() => setViewShow(false)}
        data={viewData}
        authUserData={authUserData}
        handleApproveReject={handleApproveReject}
      />
      <ReorderArticlesModal
        show={showReorder}
        handleClose={() => {
          setShowReorder(false);
          fetchTechnologyQuestions(
            searchQuestionTitle,
            { order_by: "display_order", order: "asc" },
            activePage, // Corrected from 'currentPage'
            perPage,
            id, // Using 'id' from your useParams() at the top
          );
        }}
        technologyId={id} // Using 'id' from useParams()
        versionId={versionValue} // Using 'versionValue' from your state
        techName={techName}
      />
      <Modal size="lg" show={commentShow} onHide={() => setCommentShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Article Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          {commentLoading ? (
            <div className="text-center p-5 card shadow-sm border-0">
              <DivLoader color="primary" />
              <p className="mt-2 text-muted">Loading comments...</p>
            </div>
          ) : commentData && commentData.length > 0 ? (
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <div
                  className="comment-scroll-area px-2"
                  style={{ maxHeight: "60vh", overflowY: "auto" }}
                >
                  {commentData.map((comment, index) => (
                    <div
                      key={index}
                      className="mb-4 p-3 border rounded bg-white shadow-none comment-item-hover"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <div
                            className="avatar bg-primary-lt me-2 rounded-circle d-flex align-items-center justify-content-center mr-3"
                            style={{ width: "40px", height: "40px" }}
                          >
                            {comment.name
                              ? comment.name.charAt(0).toUpperCase()
                              : "A"}
                          </div>
                          <div>
                            <h5 className="mb-0 text-dark">
                              {comment.name || "Anonymous User"}
                            </h5>
                            <small className="text-muted">
                              {comment.email}
                            </small>
                          </div>
                        </div>
                        <span
                          className={`db-status-badge ${
                            comment.is_approve === "1"
                              ? "db-badge-success"
                              : comment.is_approve === "2"
                                ? "db-badge-danger"
                                : "db-badge-warning"
                          }`}
                        >
                          {comment.is_approve === "1"
                            ? "Approved"
                            : comment.is_approve === "2"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </div>

                      <div className="text-secondary bg-light p-3 rounded mb-3 border-start border-primary border-3">
                        {comment.comment}
                      </div>

                      {/* Admin Action Buttons */}
                      <div className="d-flex gap-2 justify-content-end">
                        {comment.is_approve === "0" || !comment.is_approve ? (
                          <>
                            <Button
                              className="ml-0"
                              variant="primary"
                              onClick={() => {
                                handleUpdateStatus(comment.id, "1");
                              }}
                            >
                              Approve
                            </Button>
                            <Button
                              variant={
                              "outline-danger"
                              }
                              className="ml-3  "
                              size="sm"
                              onClick={() =>
                                handleUpdateStatus(comment.id, "2")
                              }
                            >
                              Reject
                            </Button>
                          </>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
      <div className="d-flex justify-content-center align-items-center w-100 p-5">
        <div className="card shadow-sm border-0 bg-white text-center" style={{ width: '100%', maxWidth: '500px' }}>
          <div className="card-body d-flex flex-column align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="text-muted mb-3"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              strokeWidth="1"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M8 9h1m4 0h3"></path>
              <path d="M8 13h5"></path>
              <path d="M8 4h10a2 2 0 0 1 2 2v8m-2 4h-10l-3 3v-3h-2a2 2 0 0 1 -2 -2v-8c0 -1.1 .9 -2 2 -2"></path>
              <path d="M3 3l18 18"></path>
            </svg>

            <h4 className="text-dark m-0">No comments found</h4>

            <p className="text-muted mt-2 mb-0" style={{ maxWidth: "300px" }}>
              There are currently no discussions for this article.
            </p>
          </div>
        </div>
      </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-white">
          <Button variant="secondary" onClick={() => setCommentShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function ViewArticleModal({ show, handleClose, data, authUserData, handleApproveReject }) {
  const [showRejectForm, setShowRejectForm] = useState(false);
  const [reason, setReason] = useState("");

  const isAdmin = authUserData?.[0]?.is_admin == 1;

  const handleRejectClick = () => {
    if (!showRejectForm) {
      setShowRejectForm(true);
    } else {
      if (!reason.trim()) {
        alert("Please provide a reason");
        return;
      }
      handleApproveReject(data.id, 'reject', reason);
      setShowRejectForm(false);
      setReason("");
      handleClose();
    }
  };

  return (
    <Modal size="lg" show={show} onHide={() => { handleClose(); setShowRejectForm(false); setReason(""); }}>
      <Modal.Header closeButton>
        <Modal.Title>{data?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-light">
        <div className="card shadow-sm border-0">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="text-primary m-0">Article Detailed Description</h4>
              {data?.approval_status && (
                <span className={`db-status-badge ${data.approval_status === 'approved' ? 'db-badge-success' : data.approval_status === 'rejected' ? 'db-badge-danger' : 'db-badge-warning'}`}>
                  Status: {data.approval_status ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1) : 'Pending'}
                </span>
              )}
            </div>
            <hr />
            <div className="article-content border p-4 rounded bg-white comment-item-hover" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
              {data?.description ? parse(data.description) : "No content available."}
            </div>
          </div>
        </div>

        {isAdmin && (data?.approval_status === 'pending') && (
          <div className="mt-4 p-4 border rounded bg-white shadow-sm border-primary">
            <h5 className="text-primary mb-2 d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-alert-circle me-1 me-1 text-primary mr-3" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                 <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                 <circle cx="12" cy="12" r="9"></circle>
                 <line x1="12" y1="8" x2="12" y2="12"></line>
                 <line x1="12" y1="8" x2="12" y2="13"></line>
              </svg>
              Admin Control: Review Article
            </h5>
            <p className="text-muted small mb-3">Please review this article submitted by an employee. You can either approve it for immediate listing or reject it with a comment.</p>
            
            {showRejectForm && (
              <div className="mb-3 animate__animated animate__fadeIn">
                <label className="form-label text-danger fw-bold">Provide Rejection Reason</label>
                <textarea 
                  className="form-control" 
                  rows="3" 
                  placeholder="Enter the specific reason for rejecting this article..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
              </div>
            )}
            
            <div className="d-flex gap-2">

              {!showRejectForm && (
                <Button className="mr-2"
                  variant="primary" 
                  onClick={() => {
                    handleApproveReject(data.id, 'approve');
                    handleClose();
                  }}
                >
                  Approve
                </Button>
              )}

              <Button 
                className="mr-2"
                variant={showRejectForm ? "danger" : "outline-danger"} 
                onClick={handleRejectClick}
              >
                {showRejectForm ? "Submit Rejection" : "Reject"}
              </Button>

              {showRejectForm && (
                <Button variant="secondary" onClick={() => setShowRejectForm(false)}>
                  Cancel
                </Button>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => { handleClose(); setShowRejectForm(false); setReason(""); }}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TechQuestionAnswer;